import { Link } from 'react-router-dom';
import './Features.css';

const SECTIONS = [
  {
    icon: '⚡',
    tag: 'Dispatch',
    title: '2× Faster Automated Dispatch',
    desc: 'Speed up your entire delivery cycle. Smarter dispatching, optimized prep times, every order goes out faster and hits customer promise times consistently. No more manual assignment or radio calls.',
    points: ['Auto-assign to nearest available driver', 'Priority queue for hot & high-value orders', 'Real-time load balancing across fleet', 'SLA breach alerts before they happen'],
    color: '#0057FF',
  },
  {
    icon: '🤖',
    tag: 'Automation',
    title: '99.9% Automated Order Clubbing',
    desc: 'Orders are auto-grouped and dispatched to the right driver in seconds — no manual decisions, no delays. Our algorithm maximizes drops per trip while respecting delivery windows.',
    points: ['Smart grouping by zone and time window', 'Max drops per trip optimization', 'Instant re-routing on cancellation', 'Zero human intervention required'],
    color: '#00D4FF',
    reverse: true,
  },
  {
    icon: '📊',
    tag: 'Analytics',
    title: 'Deep-Dive Performance Analytics',
    desc: 'Break down every second of delivery time — prep, fetching, waiting, drop-off — to spot improvement areas. Compare stores and fleets to see exactly what is holding you back.',
    points: ['Per-stage time breakdown', 'Cross-store benchmarking', 'Driver performance scorecards', 'Custom date range reports'],
    color: '#0057FF',
  },
  {
    icon: '🗺️',
    tag: 'Route AI',
    title: 'AI Route Optimization',
    desc: 'Our AI calculates the fastest, most cost-efficient routes in real time, adapting to traffic, distance, and driver availability automatically. Cut fuel costs and trip times simultaneously.',
    points: ['Live traffic integration', 'Multi-stop route sequencing', 'Driver skill & vehicle matching', 'Fuel & cost efficiency scoring'],
    color: '#00D4FF',
    reverse: true,
  },
  {
    icon: '📍',
    tag: 'Tracking',
    title: 'Live GPS Tracking',
    desc: 'Every delivery tracked in real time. Stores and clients see exactly where their package is at all times. Automated SMS and push updates keep customers informed without any manual effort.',
    points: ['Real-time driver location map', 'ETA updates every 60 seconds', 'Customer SMS & push notifications', 'Historical trip playback'],
    color: '#0057FF',
  },
  {
    icon: '🔒',
    tag: 'Security',
    title: 'AI Fraud Detection',
    desc: 'Route validation and anomaly detection flag suspicious activity before it costs you. Know instantly when a driver deviates from the assigned route or takes unauthorized detours.',
    points: ['Geo-fence deviation alerts', 'Anomalous stop detection', 'Tamper & spoofing protection', 'Audit trail for every trip'],
    color: '#00D4FF',
    reverse: true,
  },
];

export default function Features() {
  return (
    <main className="features-page">

      {/* HERO */}
      <section className="feat-hero">
        <div className="container">
          <p className="section-label">Platform Features</p>
          <h1>Everything You Need to<br /><span className="gradient-text">Deliver Smarter</span></h1>
          <p>Route Rover gives your operations team full visibility, automation, and intelligence — from the moment an order drops to the second it's delivered.</p>
          <Link to="/contact" className="cta-primary cta-primary--large">Get Started Free</Link>
        </div>
      </section>

      {/* FEATURE SECTIONS */}
      {SECTIONS.map((s, i) => (
        <section key={i} className={`feat-section${s.reverse ? ' feat-section--reverse' : ''}`}>
          <div className="container feat-section__inner">
            <div className="feat-section__text">
              <span className="feat-tag" style={{ color: s.color, borderColor: s.color + '40', background: s.color + '12' }}>
                {s.icon} {s.tag}
              </span>
              <h2>{s.title}</h2>
              <p>{s.desc}</p>
              <ul className="feat-points">
                {s.points.map((p, j) => (
                  <li key={j}>
                    <span className="feat-check" style={{ color: s.color }}>✓</span> {p}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="cta-primary" style={{ marginTop: 32, display: 'inline-block' }}>Request a Demo</Link>
            </div>
            <div className="feat-section__visual">
              <div className="feat-card-mock" style={{ borderColor: s.color + '30' }}>
                <div className="feat-mock-icon" style={{ background: s.color + '15', color: s.color }}>{s.icon}</div>
                <div className="feat-mock-bars">
                  {[70, 85, 55, 90, 75, 95, 65].map((h, j) => (
                    <div key={j} className="feat-mock-bar"
                      style={{ height: `${h}%`, background: `linear-gradient(180deg, ${s.color}, ${s.color}99)` }} />
                  ))}
                </div>
                <div className="feat-mock-metrics">
                  {[['Efficiency', '+40%'], ['Speed', '2×'], ['Accuracy', '99.9%']].map(([k, v]) => (
                    <div key={k} className="feat-mock-metric">
                      <span style={{ color: s.color }}>{v}</span>
                      <small>{k}</small>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA BANNER */}
      <section className="cta-banner">
        <div className="container">
          <h2>Ready to See It in Action?</h2>
          <p>Book a live demo with our team and see Route Rover transform your delivery ops.</p>
          <Link to="/contact" className="cta-primary cta-primary--large">Book a Demo</Link>
        </div>
      </section>

    </main>
  );
}
